import { Component, Story, Accents, Knobs } from './DocTypes';

const PlaygroundStoryKnobs: Knobs = {
  accent: { default: '', editor: 'dropdown', editorOptions: [''].concat(Accents) },
};
const V3PlaygroundStoryKnobs: Knobs = {
  accent: { default: '', editor: 'dropdown', editorOptions: [''].concat(Accents) },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['', 'mobile', 'desktop'],
    default: '',
  },
  backgroundImage: {
    editor: 'dropdown',
    editorOptions: ['', 'access'],
    default: '',
  },
};
const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A plain card with an empty div inside it',
  coreComponent: {
    html: `<tag-card version='2'{{...knobs}}>
  <div style='min-width:100px; min-height:60px;'></div>
</tag-card>`,
    knobs: PlaygroundStoryKnobs,
  },
  reactWrapper: {
    jsx: `<TagCard version='2'{{...knobs}}>
  <div style={{minWidth: "100px", minHeight: "60px"}}></div>
</TagCard>`,
    knobs: PlaygroundStoryKnobs,
  },
  coreComponent_v3: {
    html: `<tag3-card{{...knobs}}>
    <div style='min-width:100px; min-height:60px;'></div>
</tag3-card>
`,
    knobs: V3PlaygroundStoryKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Card{{...knobs}}>
    <div style={{minWidth: "100px", minHeight: "60px"}}></div>
    </Tag3Card>`,
    knobs: V3PlaygroundStoryKnobs,
  },
};

const KPIStory: Story = {
  title: 'KPI',
  description: 'A KPI workspace widget app using tag-card with tag-app-header and tag-stats inside',
  coreComponent: {
    html: `<tag-card
    version='2'
    accent='keppel'
    background-image='access'
    style='min-width:430px;'>
    <tag-app-header icon='LineChartSolid2' heading='Sales Order Processing KPIs' heading-accent='white'>
      <div slot='menu'>
        <tag-menu-item name='remove' icon='Delete' text='Remove'></tag-menu-item>
      </div>
    </tag-app-header>
    <tag-stats
      accent='white'
      heading='Outstanding Orders'
      sub-heading='11:15 AM'
      label-field='label'
      value-field='value'>
    </tag-stats>
</tag-card>`,
    js: `var stats = document.querySelector('tag-stats');
stats.componentOnReady().then(function() {
  stats.data = [
    { label: 'Outstanding Orders', value: '21' },
    { label: 'Order Value', value: '£66,040.98' },
  ];
});`,
    additionalEvents: ['menuItemClick'],
  },
  coreComponent_v3: {
    html: `<tag3-card
      accent='keppel'
      background-image='access'
      style='min-width:430px;'>
      <tag3-app-header icon='LineChartSolid2' icon-accent='keppel' heading='Sales Order Processing KPIs' heading-accent='white'>
        <div slot='menu'>
          <tag3-menu-item name='remove' icon='Delete' text='Remove'></tag3-menu-item>
        </div>
      </tag3-app-header>
      <tag3-stats
        accent='white'
        heading='Outstanding Orders'
        sub-heading='11:15 AM'
        label-field='label'
        value-field='value'>
      </tag3-stats>
    </tag3-card>`,
    js: `var stats = document.querySelector('tag3-stats');
    stats.data = [
      { label: 'Outstanding Orders', value: '21' },
      { label: 'Order Value', value: '£66,040.98' },
    ];`,
  },
  reactWrapper: {
    jsx: `<TagCard
    version='2'
    accent='keppel'
    background-image='access'
    style={{minWidth: "430px"}}>
    <TagAppHeader
      icon='LineChartSolid2'
      heading='Sales Order Processing KPIs'
      heading-accent='white'
      menuItems={[
        {
          icon: 'Delete',
          name: 'remove',
          text: 'Remove',
        },
      ]}
    />
    <TagStats
      accent='white'
      heading='Outstanding Orders'
      subHeading='11:15 AM'
      labelField='label'
      valueField='value'
      data={[
        { label: 'Outstanding Orders', value: '21' },
        { label: 'Order Value', value: '£66,040.98' },
      ]}
    />
  </TagCard>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Card
    accent='keppel'
    background-image='access'
    style={{minWidth: "430px"}}>
    <Tag3AppHeader
      icon='LineChartSolid2'
      iconAccent='keppel'
      heading='Sales Order Processing KPIs'
      heading-accent='white'
      menuItems={[
        {
          icon: 'Delete',
          name: 'remove',
          text: 'Remove',
        },
      ]}
    />
    <Tag3Stats
      accent='white'
      heading='Outstanding Orders'
      subHeading='11:15 AM'
      labelField='label'
      valueField='value'
      data={[
        { label: 'Outstanding Orders', value: '21' },
        { label: 'Order Value', value: '£66,040.98' },
      ]}
    />
  </Tag3Card>`,
  },
};

const ActionsStory: Story = {
  title: 'Actions',
  description:
    'A workspace widget app that allows a user to do a couple of invoice related operations for a school',
  coreComponent: {
    html: `<tag-card version='2' accent='component-background' background-image='access' style='min-width:350px;'>
  <tag-app-header icon='Circle' icon-accent='navy' heading='Create Invoice' >
    <div slot='menu'>
      <tag-menu-item name='remove' icon='Delete' text='Remove'></tag-menu-item>
    </div>
  </tag-app-header>
  <div style='display: flex; padding:15px; flex-wrap: wrap;'>
    <div>
      <tag-combobox
        text-field='school'
        value-field='school'
        value='Westminster School'
        borderless
        input-disabled
        input-style='{"font-size": "18px", "font-weight": "600", "background-color": "transparent", "white-space": "nowrap", "overflow": "hidden", "text-overflow": "ellipsis"}'
        style='width:210px;'
        data-id='school'>
      </tag-combobox>
      <tag-text type='span' text='Code:'></tag-text>
      <tag-text type='span' data-id='schoolCode' text='9675'></tag-text>
    </div>
    <tag-combobox
      text-field='year'
      value-field='year'
      value='2018'
      borderless
      input-disabled
      input-style='{"font-size": "18px", "font-weight": "600", "background-color": "transparent"}'
      style='width:90px;margin-left:auto'
      data-id='year'>
    </tag-combobox>
  </div>
  <div style='display: flex; padding:15px; flex-wrap: wrap;'>
    <tag-button
      icon='ArrowTopRight'
      icon-accent='white'
      accent='navy'
      text='Invoice From GRN'
      data-id='invoiceFromGRN'>
    </tag-button>
    <tag-button
      icon='ArrowTopRight'
      icon-accent='white'
      accent='navy'
      text='Non Order Invoice'
      data-id='nonOrderInvoice'
      style='margin-left:auto'>
    </tag-button>
  </div>
</tag-card>`,
    js: `var schoolCombobox = document.querySelector("tag-combobox[data-id='school']");
  schoolCombobox.componentOnReady().then(function() {
    schoolCombobox.data = [
      { school: 'Abington Vale Primary School', code: '1238' },
      { school: 'Perse Upper School', code: '7288' },
      { school: 'Westminster School', code: '9675' },
      { school: 'Wycombe Abbey School', code: '7425' },
    ];
    schoolCombobox.addEventListener('valueChange', function(e) {
      var schoolCode = document.querySelector("tag-text[data-id='schoolCode']");
      schoolCode.text = e.detail.item.code;
    });
  });
  var yearCombobox = document.querySelector("tag-combobox[data-id='year']");
  yearCombobox.componentOnReady().then(function() {
    yearCombobox.data = [{ year: '2018' }, { year: '2017' }, { year: '2016' }];
  });

  var grnInvoice = document.querySelector("tag-button[data-id='invoiceFromGRN']");
  grnInvoice.componentOnReady().then(function() {
    grnInvoice.addEventListener('buttonClick', function() {
      console.log('Invoice from GRN');
    });
  });
  var nonOrderInvoice = document.querySelector("tag-button[data-id='nonOrderInvoice']");
  nonOrderInvoice.componentOnReady().then(function() {
    nonOrderInvoice.addEventListener('buttonClick', function() {
      console.log('Non Order Invoice');
    });
  });`,
    additionalEvents: ['menuItemClick', 'buttonClick', 'valueChange'],
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [schoolCode, setSchoolCode] = React.useState('9675');
    const [year, setYear] = React.useState('2018');
    return (
      <TagCard version='2' accent='component-background' background-image='access' style={{minWidth: "350px"}}>
        <TagAppHeader
          icon='Circle'
          icon-accent='navy'
          heading='Create Invoice'
          menuItems={[
            {
              icon: 'Delete',
              name: 'remove',
              text: 'Remove',
            },
          ]}
        />
        <div style={{display: "flex", padding: "15px", flexWrap: "wrap"}}>
          <div>
            <TagCombobox
              textField='school'
              valueField='school'
              value='Westminster School'
              borderless
              inputDisabled
              inputStyle={{fontSize: "18px", fontWeight: "600", backgroundColor: "transparent", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}
              style={{width: "210px"}}
              data={[
                { school: 'Abington Vale Primary School', code: '1238' },
                { school: 'Perse Upper School', code: '7288' },
                { school: 'Westminster School', code: '9675' },
                { school: 'Wycombe Abbey School', code: '7425' }
              ]}
              onValueChange={(e) => setSchoolCode(e.detail.item.code)}
            />
            <TagText type='span' text='Code:' />
            <TagText type='span' text={schoolCode} />
          </div>
          <TagCombobox
            textField='year'
            valueField='year'
            value='2018'
            borderless
            inputDisabled
            inputStyle={{fontSize: "18px", fontWeight: "600", backgroundColor: "transparent"}}
            style={{width: "90px", marginLeft: "auto"}}
            data={[{ year: '2018' }, { year: '2017' }, { year: '2016' }]}
            onValueChange={(e) => setYear(e.detail.item.year)}
          />
        </div>
        <div style={{display: "flex", padding: "15px", flexWrap: "wrap"}}>
          <TagButton
            icon='ArrowTopRight'
            iconAccent='white'
            accent='navy'
            text='Invoice From GRN'
            onButtonClick={() => alert('Invoice From GRN for ' + schoolCode + ' for ' + year)}
          />
          <TagButton
            icon='ArrowTopRight'
            iconAccent='white'
            accent='navy'
            text='Non Order Invoice'
            data-id='nonOrderInvoice'
            style={{marginLeft:"auto"}}
            onButtonClick={() => alert('Non Order Invoice for ' + schoolCode + ' for ' + year)}
          />
        </div>
      </TagCard>
    )
  };
  `,
  },
};

export const TagCardDocs: Component = {
  type: 'component',
  name: 'card',
  description: 'Renders content in a card',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'version',
      description:
        'V1 Only: The version of the component. This should be set to 2 to get the latest features and styles',
      type: 'string',
    },
    {
      name: 'accent',
      description: 'The background colour of the card',
      type: 'string',
    },
    {
      name: 'backgroundImage',
      description: 'Adds SVG background image to card.',
      type: '"access" | undefined',
    },
    {
      name: 'colourScheme',
      description:
        'V3 only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 only: Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory, KPIStory, ActionsStory],
};
